import issueDescription from "./issue_description";
import reason from "./reason";

export default {
  issueDescription,
  reason,
  displayName: "Topic WITHOUT Parameter Present",
  order: 350,
};
